import { useMemo } from 'react'
import { Bot, Smile } from 'lucide-react'
import type { AdminColumn } from '@/components/DataTable/types'
import { ModListScreen } from './ModListScreen'
import { makeFetcher, MOD_STR as S, type BotModRow, type StickerModRow } from './modContentApi'

/**
 * A6.09 — Bot / Mini App moderatsiyasi. Bot va Mini App kontentini ko'rib chiqish
 * navbati (GET /admin/moderation/bots). Review-only; auto-act qilmaydi.
 */
export function BotModerationScreen() {
  const columns = useMemo<AdminColumn<BotModRow>[]>(
    () => [
      { key: 'id', header: 'ID', type: 'id' },
      { key: 'bot_username', header: S.botUsername, type: 'text' },
      { key: 'owner', header: S.owner, type: 'text' },
      { key: 'kind', header: S.kind, type: 'text' },
      { key: 'category', header: S.category, type: 'text' },
      { key: 'status', header: S.status, type: 'text' },
      { key: 'flags', header: S.flags, type: 'number' },
      { key: 'created_at', header: S.created, type: 'date' },
    ],
    [],
  )
  return (
    <ModListScreen<BotModRow>
      screenId="A6.09"
      title={S.bots}
      description={S.botsDesc}
      columns={columns}
      fetcher={makeFetcher<BotModRow>(
        '/admin/moderation/bots',
        'bots',
        (r) => `${r.bot_username} ${r.owner} ${r.category}`,
      )}
      rowId={(r) => String(r.id)}
      icon={<Bot size={28} strokeWidth={1.5} />}
    />
  )
}

/**
 * A6.10 — Stiker / emoji moderatsiyasi. Stiker to'plamlari va maxsus emojilarni
 * ko'rib chiqish (GET /admin/moderation/stickers).
 */
export function StickerEmojiModerationScreen() {
  const columns = useMemo<AdminColumn<StickerModRow>[]>(
    () => [
      { key: 'id', header: 'ID', type: 'id' },
      { key: 'set_title', header: S.setTitle, type: 'text' },
      { key: 'owner', header: S.owner, type: 'text' },
      { key: 'kind', header: S.kind, type: 'text' },
      { key: 'category', header: S.category, type: 'text' },
      { key: 'status', header: S.status, type: 'text' },
      { key: 'created_at', header: S.created, type: 'date' },
    ],
    [],
  )
  return (
    <ModListScreen<StickerModRow>
      screenId="A6.10"
      title={S.stickers}
      description={S.stickersDesc}
      columns={columns}
      fetcher={makeFetcher<StickerModRow>(
        '/admin/moderation/stickers',
        'items',
        (r) => `${r.set_title} ${r.owner} ${r.category}`,
      )}
      rowId={(r) => String(r.id)}
      icon={<Smile size={28} strokeWidth={1.5} />}
    />
  )
}
